import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown, ChevronRight, Layers } from 'lucide-react';
import { ExportCard } from './ExportCard';
import { GRANULARITY_OPTIONS } from './constants';

export const ExportSection = ({
  sectionKey, title, icon, options, bgColor = 'bg-white', iconColor = 'text-[#2E5C8A]',
  showGranularity = false, expanded, onToggle,
  exportGranularity, setExportGranularity,
  exporting, exportProgress, onExport
}) => (
  <div className="mb-6">
    <button
      onClick={() => onToggle(sectionKey)}
      className={`w-full flex items-center justify-between p-4 ${bgColor} rounded-xl border border-border hover:bg-opacity-80 transition-colors`}
      data-testid={`section-toggle-${sectionKey}`}
    >
      <div className="flex items-center gap-3">
        {React.createElement(icon, { size: 20, className: iconColor })}
        <span className="font-semibold text-foreground">{title}</span>
        <span className="text-sm text-muted-foreground">({options.length} options)</span>
      </div>
      {expanded ? <ChevronDown size={20} /> : <ChevronRight size={20} />}
    </button>

    {expanded && (
      <motion.div
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: 1, height: 'auto' }}
        exit={{ opacity: 0, height: 0 }}
      >
        {showGranularity && (
          <div className="flex items-center gap-3 mt-4 mb-2 px-1" data-testid="granularity-selector">
            <div className="flex items-center gap-2 text-sm font-medium text-slate-600">
              <Layers size={16} />
              Granularity:
            </div>
            {GRANULARITY_OPTIONS.map(g => (
              <button
                key={g.id}
                onClick={() => setExportGranularity(g.id)}
                className={`px-3 py-1.5 rounded-full text-sm font-medium transition-all ${
                  exportGranularity === g.id
                    ? 'bg-[#2E5C8A] text-white shadow-sm'
                    : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                }`}
                data-testid={`granularity-${g.id}`}
              >
                {g.label}
              </button>
            ))}
            {exportGranularity !== 'summary' && (
              <span className="text-xs text-slate-400 ml-1">
                Data grouped by {exportGranularity} period + employee
              </span>
            )}
          </div>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
          {options.map(option => (
            <ExportCard
              key={option.id}
              option={option}
              exporting={exporting}
              exportProgress={exportProgress}
              onExport={onExport}
            />
          ))}
        </div>
      </motion.div>
    )}
  </div>
);
